module.exports = __webpack_public_path__ + "static/media/cq_calendario b.004ab697.svg";